import { useSnackbar } from "@gemini/ui";
import { useI18n } from "@/contexts/i18n";
import { useHardFactsTitle } from "@/contexts/classified";
import { IS_SERVER } from "@/constants";
import { useConfig } from "@/contexts/cdpConfig";
export const useShare = () => {
    const { t } = useI18n();
    const { add } = useSnackbar();
    const { title } = useHardFactsTitle();
    const isPreviewMode = useConfig().previewMode;
    if (IS_SERVER)
        return {
            copyShare: () => undefined,
            nativeMobileShare: () => undefined,
        };
    const copyShare = async () => {
        var _a;
        if (IS_SERVER || isPreviewMode)
            return;
        try {
            await window.navigator.clipboard.writeText((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href);
            add({
                description: t("common.CTA.copyShare.success"),
                variant: "success",
            });
        }
        catch (_b) {
            add({
                description: t("common.CTA.copyShare.error"),
                variant: "error",
            });
        }
    };
    const nativeMobileShare = () => {
        var _a;
        if (IS_SERVER || isPreviewMode)
            return;
        const shareData = {
            url: (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href,
            text: t("common.CTA.nativeShare.text"),
            title,
        };
        if ((window === null || window === void 0 ? void 0 : window.navigator["share"]) && (window === null || window === void 0 ? void 0 : window.navigator.canShare(shareData))) {
            window.navigator.share(shareData);
        }
        else {
            add({
                description: t("common.CTA.nativeShare.error"),
                variant: "error",
            });
        }
    };
    return {
        copyShare,
        nativeMobileShare,
    };
};
